export const PAGINATION_SIZE = 8;

// Header logo served from the site's own Sanity CDN — the last-resort
// og:image / Organization logo when a route has no media of its own and
// Shopify brand assets are not configured in admin.
export const HELMETKING_LOGO_URL =
  'https://cdn.sanity.io/images/7m88emnx/production/06610095f77a6e7bf96b6d11ba253d42e8f77fca-600x143.png';

// Marsello's hosted customer portal (loyalty hub) — customers sign up /
// log in there directly to see points, redeem rewards and get coupon codes.
export const MARSELLO_PORTAL_URL = 'https://helmetking.marsello.app';

// Canonical NAP (name / address / phone) facts, shared by the Organization
// JSON-LD (seo.server.ts), the store-locator's Store JSON-LD and llms.txt so
// the entity data can never drift between surfaces. Values mirror the
// flagship entry in store-locator.tsx's STORES and the site footer.
export const HELMETKING_TELEPHONE = '+852 6385 8830';
export const HELMETKING_EMAIL = 'info@helmetking.com';
export const HELMETKING_ADDRESS = {
  '@type': 'PostalAddress',
  streetAddress: 'Shop 1, G/F, Po Hang Building, 2-8 Dundas Street',
  addressLocality: 'Mong Kok',
  addressRegion: 'Kowloon',
  addressCountry: 'HK',
} as const;
// From the shop's own terms & conditions (§2: 頭盔王 HelmetKing（MOTOBLOG
// LIMITED）) — strengthens entity identification for search/AI engines.
export const HELMETKING_LEGAL_NAME = 'MOTOBLOG LIMITED';
export const DEFAULT_GRID_IMG_LOAD_EAGER_COUNT = 4;
export const ATTR_LOADING_EAGER = 'eager';

export function getImageLoadingPriority(
  index: number,
  maxEagerLoadCount = DEFAULT_GRID_IMG_LOAD_EAGER_COUNT,
) {
  return index < maxEagerLoadCount ? ATTR_LOADING_EAGER : undefined;
}
